import { useCallback, useMemo, useState } from 'react';

import { CSRF_COOKIE_NAME, CSRF_HEADER_NAME } from '../constants';
import { devMessage } from '../settings/settings';
import { getLangForTranslations } from '../utils/langUtil';
import { getFullApiUrl } from '../utils/navigationUtil';
import { getCookie, REQUEST_STATUS } from '../utils/requestUtil';
import useReadCartExpiration from './useReadCartExpiration';

const usePost = (url, jsonData) => {
  const CURRENT_APP_LANG = useMemo(() => getLangForTranslations(), []);

  const payload = JSON.stringify(jsonData);
  const [data, setData] = useState(null);
  const [status, setStatus] = useState(REQUEST_STATUS.LOADING);
  const hasExpired = useReadCartExpiration();

  const executePost = useCallback(() => {
    if (hasExpired) return;
    if (jsonData === null) return; // This can happen when react reloads state

    const abortController = new AbortController();

    const fullUrl = getFullApiUrl(url);
    devMessage('POST:', fullUrl);
    devMessage('POST-DATA:', jsonData);
    fetch(fullUrl, {
      method: 'POST',
      body: payload,
      headers: {
        'Content-Type': 'application/json',
        [CSRF_HEADER_NAME]: getCookie(CSRF_COOKIE_NAME),
        'Accept-Language': CURRENT_APP_LANG,
      },
      credentials: 'include', // Required to store/retransmit ajax cookies (csrf/session) !!
      signal: abortController.signal,
    })
      .then(res => {
        if (!res.ok) throw Error();
        return res.json();
      })
      .then(data => {
        devMessage('POST-RESPONSE:', data);
        setData(data);
        setStatus(REQUEST_STATUS.OK);
      })
      .catch(err => {
        if (err.name === 'AbortError') return;

        console.error(err);
        setStatus(REQUEST_STATUS.ERROR);
      });
    // return () => abortController.abort(); A VOIR
  }, [url, payload]);

  const resetPost = () => {
    setStatus(REQUEST_STATUS.LOADING);
    setData(null);
  };

  return { data, status, executePost, resetPost };
};

export default usePost;
